var _defs, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEduBricks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.47 347.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #87a7d6;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #b1dfde;\n      }\n\n      .cls-3 {\n        fill: #f0503e;\n      }\n\n      .cls-4 {\n        fill: #fdb813;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m150.74,197.62C67.49,197.62,0,264.92,0,347.95h75.57c0-41.51,33.65-75.17,75.17-75.17h0c41.51.02,75.15,33.66,75.15,75.17h75.58c0-83.03-67.49-150.33-150.73-150.33Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.89,39.5c0,41.51-33.65,75.17-75.17,75.17v75.17c83.25,0,150.73-67.31,150.73-150.33h-75.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.58,39.5H0c0,83.03,67.49,150.33,150.73,150.33v-75.17c-41.51-.02-75.14-33.66-75.15-75.17Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m108.73,42.02c0,23.22,18.8,42.02,42,42.02s42.02-18.8,42.02-42.02S173.95,0,150.73,0s-42,18.81-42,42.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduBricks);
export default __webpack_public_path__ + "static/media/eduBricks.b64082c17000eea987f568e1aca53eb1.svg";
export { ForwardRef as ReactComponent };